import {Controller} from "@hotwired/stimulus";

// Cart and watch list overviews (carts/current, watch_lists/current). The row
// buttons - cart_trash, cart_watch_move, cart_button and the legacy
// watch_list.js trash - each drop their own <tr>. Once the last one is gone,
// this swaps the list (on the cart including the checkout form) for the empty
// state the server renders for an empty list, without a reload.
export default class extends Controller {
    static targets = ["row", "list", "empty"];

    rowTargetDisconnected() {
        if (this.rowTargets.length > 0) return;
        if (this.hasListTarget) this.listTarget.remove();
        if (this.hasEmptyTarget) this.emptyTarget.hidden = false;
    }
}
